import { useAuth } from "reactfire";
import React, { useEffect, useState } from "react";
import BarLoader from "react-spinners/BarLoader";
import { FormGroup, Container, Row, Col } from "react-bootstrap";
import Alert from "../../../../shared/components/alert/Alert";
import { useHistory } from "react-router-dom";
import CheckBox from "../../../../shared/components/ui/check-box/CheckBox";
import { useAppUser } from "../../../../contexts/user-context/UserContext";
import * as firebase from "firebase/app";

interface IState {
  email: string;
  password: string;
  hasError: boolean;
  errorMessage: string;
  loading: boolean;
  staySignIn: boolean;
}

const initState: IState = {
  email: "",
  password: "",
  hasError: false,
  errorMessage: "",
  loading: false,
  staySignIn: false,
};

const LoginForm = () => {
  const [state, setState] = useState(initState);
  const auth = useAuth();
  const history = useHistory();
  const appUser = useAppUser();

  useEffect(() => {
    if (localStorage.getItem("isAuthed") === "true" || appUser.fireUser) {
      if (appUser.userRole.isModerator) {
        history.push("/dashboard");
      } else if (!appUser.userRole.isModerator && appUser.userRole.isMember) {
        history.push("/dashboard/library/workshops");
      }
    }
  }, [appUser, history]);

  const login = () => {
    setState({ ...state, loading: true });
    auth
      .setPersistence(
        state.staySignIn
          ? firebase.auth.Auth.Persistence.LOCAL
          : firebase.auth.Auth.Persistence.SESSION
      )
      .then(() => {
        if (appUser.userRole.isModerator) {
          history.push("/dashboard");
        } else if (!appUser.userRole.isModerator && appUser.userRole.isMember) {
          history.push("/dashboard/library/workshops");
        }

        return auth
          .signInWithEmailAndPassword(state.email, state.password)
          .then((signedInUser) => {
            if (state.staySignIn) {
              localStorage.setItem("isAuthed", "true");
              sessionStorage.setItem("isAuthed", "true");
            } else {
              sessionStorage.setItem("isAuthed", "true");
              localStorage.setItem("isAuthed", "false");
            }

            signedInUser.user?.getIdTokenResult().then((res) => {
              if (res.claims.isModerator) {
                history.push("/dashboard");
              } else if (!res.claims.isModerator && res.claims.isMember) {
                history.push("/dashboard/library/workshops");
              }
            });
          })
          .catch((error) => {
            sessionStorage.setItem("isAuthed", "false");
            localStorage.setItem("isAuthed", "false");

            const errorMessage: string = error.code || "";

            if (errorMessage.includes("user-disabled")) {
              setState((ps) => ({
                ...ps,
                hasError: true,
                errorMessage:
                  "Your profile has been deactivated. \n" +
                  "If you think this is a mistake, please contact the organizers at contact-in@ieee.org",
              }));
            } else if (errorMessage.includes("auth/user-not-found")) {
              setState((ps) => ({
                ...ps,
                hasError: true,
                errorMessage: "Invalid username",
              }));
            } else if (errorMessage.includes("auth/wrong-password")) {
              setState((ps) => ({
                ...ps,
                hasError: true,
                errorMessage: "Invalid password",
              }));
            } else {
              setState((ps) => ({
                ...ps,
                hasError: true,
                errorMessage: "Please check your network connection",
              }));
            }
          });
      })
      .catch((err) => {
        setState((ps) => ({ ...ps, hasError: true }));
      })
      .finally(() => {
        setState((ps) => ({ ...ps, loading: false }));
      });
    // auth
    //   .signInWithEmailAndPassword(state.email, state.password)
    //   .then((res) => {
    //     history.push("/dashboard/home");
    //   })
    //   .catch((err) => {
    //     setState({ ...state, hasError: true, loading: false });
    //   })
    //   .finally(() => {});
  };

  return (
    <Container className="h-100">
      <Row className="h-100 justify-content-center ">
        <Col
          xs={12}
          style={{ marginTop: "13%" }}
          className="d-flex justify-content-center "
        >
          <div style={{ width: "550px" }}>
            <form
              onSubmit={(e: any) => {
                e.preventDefault();
                !state.loading && login();
              }}
            >
              <FormGroup style={{ marginBottom: "35px" }}>
                <h1
                  className="text-center color-white"
                  style={{ fontSize: "30px" }}
                >
                  Hello there, Welcome back !
                </h1>
              </FormGroup>

              {state.hasError && (
                <FormGroup>
                  <Alert
                    show={state.hasError}
                    onClose={() =>
                      setState({ ...state, hasError: false, errorMessage: "" })
                    }
                  >
                    <b>ERROR!</b> {state.errorMessage}
                  </Alert>
                </FormGroup>
              )}
              <div style={{ paddingLeft: "75px", paddingRight: "75px" }}>
                <FormGroup>
                  <input
                    className="login-input"
                    placeholder="Email"
                    value={state.email}
                    onChange={(e) => {
                      setState({
                        ...state,
                        email: e.target.value,
                        hasError: false,
                        errorMessage: "",
                      });
                    }}
                  />
                </FormGroup>
                <FormGroup className="mt-4">
                  <input
                    className="login-input"
                    placeholder="Password"
                    type="password"
                    value={state.password}
                    onChange={(e) => {
                      setState({
                        ...state,
                        password: e.target.value,
                        hasError: false,
                        errorMessage: "",
                      });
                    }}
                  />
                </FormGroup>
                {state.loading && (
                  <FormGroup>
                    <BarLoader
                      height={4}
                      width={"100%"}
                      color={"#fff"}
                      loading={state.loading}
                    />
                  </FormGroup>
                )}
                <FormGroup className="text-right">
                  <button className="login-button" type="submit">
                    Log In
                  </button>
                </FormGroup>
                <Container fluid style={{ marginTop: "4rem" }}>
                  <Row className="align-content-between">
                    <Col className="text-left pl-1">
                      <CheckBox
                        checked={state.staySignIn}
                        label="Stay signed in"
                        onSelect={(b) => setState({ ...state, staySignIn: b })}
                      />
                    </Col>
                    <Col
                      className="text-right px-0"
                      style={{ lineHeight: "18px" }}
                    >
                      <label
                        className="login-link-label mb-0"
                        style={{
                          fontSize: "16px",
                          textDecoration: "underline",
                        }}
                        onClick={() => {
                          history.push("/resetPassword");
                        }}
                      >
                        Forgot password?
                      </label>
                    </Col>
                  </Row>
                </Container>
              </div>
            </form>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default LoginForm;
